import { graphql } from "@cappelendamm/crystallize-types/core/gql";
const GetSubscriptionContractCoreQuery = graphql(`
  query GetSubscriptionContractCore($id: String!) {
    subscriptionContract(id: $id) {
      __typename
      ... on SubscriptionContractAggregate {
        id
        meta {
          key
          value
        }
        customerIdentifier
        customer {
          type
          identifier
          firstName
          lastName
          birthDate
          phone
          email
          parents {
            identifier
            type
          }
          addresses {
            type
            firstName
            lastName
            street
            postalCode
            city
            country
            email
            phone
          }
          externalReferences {
            key
            value
          }
          meta {
            key
            value
          }
        }
        payment {
          __typename
          ... on CustomPayment {
            provider
            properties {
              property
              value
            }
          }
        }
        addresses {
          type
          firstName
          lastName
          street
          postalCode
          city
          country
          email
          phone
        }
        item {
          name
          sku
          imageUrl
          quantity
          meta {
            key
            value
          }
        }
        status {
          activeUntil
          renewAt
          phase {
            price
            currency
            period
            unit
          }
        }
        initial {
          currency
          price
          period
          unit
        }
        recurring {
          price
          currency
          period
          unit
        }
        createdAt
      }
      ... on ExperimentalFeaturesNotAvailableError {
        errorName
        message
      }
      ... on BasicError {
        errorName
        message
      }
    }
  }
`);
export const getSubscriptionContract = async ({ contractId }, { client }) => {
    const data = await client.core.request(GetSubscriptionContractCoreQuery, {
        id: contractId,
    });
    const result = data.subscriptionContract;
    if (!result || result.__typename !== "SubscriptionContractAggregate") {
        throw new Error(`No subscription contract found for id: ${contractId}. Error: ${result?.message || "Unknown error"}`);
    }
    return result;
};
